<adapt-feature-guidance>
    <p>We expose an API that developers can use to retrieve data from Lumia - allowing them to create custom integrations, visualisations or
        analysis.</p>
    <p>
        General information about the API is available
        <a href="https://support.theadaptway.com/developer-api">here</a>, and technical documentation for the API is available <a
           href="https://api.theadaptway.com/swagger/">here</a>.
    </p>
</adapt-feature-guidance>

<adapt-feature-configuration [configItem]="configItem">
    @if (featureIsEnabledAndSaved) {
        @if (apiEntries.length < 1) {
            <div>There are no existing API tokens registered for this organisation.</div>
        } @else {
            <label>Existing API tokens</label>
            <dx-data-grid [dataSource]="apiEntries"
                          [allowColumnReordering]="true"
                          [allowColumnResizing]="true"
                          [columnAutoWidth]="true"
                          [rowAlternationEnabled]="true">
                <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
                <dxo-data-grid-header-filter [visible]="true"></dxo-data-grid-header-filter>
                <dxi-data-grid-column dataField="person.fullName"
                                      dataType="string"
                                      caption="Person"
                                      cellTemplate="personNameLinkCellTemplate"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="createdDateTime"
                                      dataType="date"
                                      caption="Created"
                                      [format]="dateFormat"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="lastUsedDateTime"
                                      dataType="date"
                                      caption="Last used"
                                      [format]="dateFormat"
                                      [customizeText]="lastUsedDateTimeText"></dxi-data-grid-column>
                <dxi-data-grid-column caption="Actions"
                                      cellTemplate="actionsCellTemplate"></dxi-data-grid-column>
                <div *dxTemplate="let data of 'personNameLinkCellTemplate'">
                    <adapt-link-person [person]="data.data.person"></adapt-link-person>
                </div>
                <div *dxTemplate="let data of 'actionsCellTemplate'">
                    <button adaptButton="delete"
                            (click)="deleteApiToken(data.data)"></button>
                </div>
            </dx-data-grid>
        }
        <div class="d-flex mt-3">
            @if (!isCreating) {
                <button adaptButton="add"
                        class="me-2"
                        [adaptBlockingClick]="addNewApi"
                        data-test="api-add">API token</button>
            }
            @if (isCreating && newApi) {
                <div class="d-flex align-items-center">
                    <div class="form-group">
                        <label for="selectPerson">Person</label>
                        <adapt-select-person id="selectPerson"
                                             [(person)]="newApi.person"
                                             [required]="true"
                                             [filter]="filterExistingApiPeople"></adapt-select-person>
                    </div>
                    <button class="ms-2"
                            adaptButton="add"
                            [disabled]="newApi.entityAspect.hasValidationErrors"
                            (click)="saveNewApi()"
                            data-test="api-add"></button>
                    <button adaptButton="cancel"
                            [adaptBlockingClick]="cancelNewApi"></button>
                </div>
            }
        </div>
    }
</adapt-feature-configuration>
